<template>
    <flex-element
        tag="ul"
        class="bypass-block"
    >
        <collection-link
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :index="index"
            v-bind="element"
            :pointer="index + 1"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],
};
</script>
